import { DialogUI } from '../../../Interface';
import { useSimpleTask } from '../../../../hooks/useSimpleTask';
import { useEffect, useState } from 'react';
import { SimpleTaskForm } from '../../../NewSimpleTask/SimpleTaskForm';

const SimpleTaskDialog = ({ open, handleClose, changed, task, submenuNames, editing, dialogData = {} }) => {
  const { taskChanged, setTaskChanged } = changed;
  const simpleTaskState = useSimpleTask();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (task) {
      simpleTaskState.setSelectedValues(task);
      if (editing) {
        simpleTaskState.setViewField(false);
        simpleTaskState.setEditButtonvisible(false);
      }
      setIsUpdate(true);
    }
  }, [task, simpleTaskState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={task?.simpleTaskName ?? submenuNames[0]}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <SimpleTaskForm
        dialog={{
          handleClose: handleClose,
          taskChanged: taskChanged,
          setTaskChanged: setTaskChanged,
          isUpdate: isUpdate,
          dialogData,
          editing,
        }}
        simpleTaskState={simpleTaskState}
      />
    </DialogUI>
  );
};

export default SimpleTaskDialog;
